<div class="row d-flex pagination-bar">
  <div class="col-md-3 col-12">
    <div class="d-flex justify-content-between align-items-center">
      <label class="d-flex align-items-center lc-pos-pagination__label">
        Afficher
        <select
          class="form-control mx-25"
          [ngModel]="pageSize"
          (ngModelChange)="onPageSizeChange($event)"
        >
          <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{ size }}</option>
        </select>
      </label>
    </div>
  </div>
  <div class="col-md-9 col-12 pagination-col">
    <div class="pagination-row d-flex justify-content-end gap-2">
      <div class="page-box" [class.disabled]="currentPage === 1" (click)="changePage(1)">«</div>
      <div class="page-box" [class.disabled]="currentPage === 1" (click)="changePage(currentPage - 1)">‹</div>
      <div
        *ngFor="let page of pages"
        class="page-box"
        [class.active]="page === currentPage"
        (click)="changePage(page)"
      >
        {{ page }}
      </div>
      <div
        class="page-box"
        [class.disabled]="currentPage === totalPages"
        (click)="changePage(currentPage + 1)"
      >
        ›
      </div>
      <div
        class="page-box"
        [class.disabled]="currentPage === totalPages"
        (click)="changePage(totalPages)"
      >
        »
      </div>
    </div>
  </div>
</div>
